
import axios from "axios";
import { Config } from "../../../core/config/config";
import { processLoadOptions } from "@/core/helper/datasource-query-helper";

const GATEWAY_URL = `${Config.VITE_APP_GATEWAY_URL}/api/replenishment/productrecipe`;

export const productRecipeService = {

    getOrderList: async function (ProductCode: string) {
        return axios.get(`${GATEWAY_URL}/get_product_recipes`, {
            params: {
                ProductCode: ProductCode
            }
        })
            .then((response) => {
                return response.data;
            });
    },

    getOrderDetailList: async function (loadOptions: any) {
        const params = processLoadOptions(loadOptions);
        return axios.get(`${GATEWAY_URL}/get_product_recipe_details`, {
            params
        })
            .then((response) => {
                return response.data;
            });
    },

    getAddOrDetailList: async function (ProductCode: string) {
        return axios.get(`${GATEWAY_URL}/get_product_recipes_add`, {
            params: {
                ProductCode: ProductCode
            }
        })
            .then((response) => {
                return response.data;
            });
    },

    saveee: async function (values: any) {
        return axios.put(`${GATEWAY_URL}/save_product_recipes`, values)
            .then((response) => {
                return response.data;
            });
    },
}
